import {ReactNode, useMemo} from 'react';
import {createPortal} from 'react-dom';

interface IProps {
  children: ReactNode;
  elementId?: string;
}

const Portal = ({children, elementId}: IProps) => {
  const container = useMemo(
    () => document.getElementById(elementId || 'portal'),
    [elementId]
  );

  if (!container) {
    return null;
  }

  return createPortal(children, container);
};

export default Portal;
